import React from 'react'

import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import * as Sentry from '@sentry/react'

import { sessionId, useSessionCheck } from 'mailup-react-helpers'

import { routesAccessConditions } from 'Config/config'

import ErrorBoundaryReactRouterV6 from 'Containers/ErrorBoundaryReactRouterV6'

import Home from 'Pages/Home'

import AuthPage from './pages/authPage'
import NoMatchPage from './pages/NoMatchPage'

import CategoriesListPage from './pages/newCategoriesListPage/index'
import NoAuthPage from './pages/NoAuthPage'
import UnifiedFiltersListPage from './pages/unifiedFiltersListPage'
import CombinedFilterFormPage from './pages/combinedFilterFormPage'

import { AccountsApiProvider } from './providers/AccountsApiProvider'
import { ApiProvider } from './providers/ApiProvider'
import { AppStateProvider } from './providers/AppStateProvider'
import { BeAccountsApiProvider } from './providers/BeAccountsApiProvider'
import { BeFiltersApiProvider } from './providers/BeFiltersApiProvider'
import { BeListApiProvider } from './providers/BeListApiProvider'
import { BeMessApiProvider } from './providers/BeMessApiProvider'
import { BeRecipientApiProvider } from './providers/BeRecipientApiProvider'
import { ConditionEvaluatorProvider } from './providers/ConditionEvaluatorProvider'
import { GeolocationApiProvider } from './providers/GeolocationApiProvider'

import ErrorBoundary from './containers/ErrorBoundary'

import { onboard, withAuth } from 'Helpers/withAuth'

const router = Sentry.wrapCreateBrowserRouter(createBrowserRouter)(
  [
    {
      path: '/',
      Component: Home,
      ErrorBoundary: ErrorBoundaryReactRouterV6,
      children: [
        {
          path: '/auth',
          Component: AuthPage,
        },
        {
          path: '/filters/list',
          Component: withAuth(
            UnifiedFiltersListPage,
            NoAuthPage,
            routesAccessConditions.filter,
            onboard,
          ),
        },
        {
          path: '/filters/form/:id',
          Component: withAuth(
            CombinedFilterFormPage,
            NoAuthPage,
            routesAccessConditions.combinedFilterForm,
            onboard,
          ),
        },
        {
          path: '/filter/engagement-upselling',
          Component: withAuth(
            UnifiedFiltersListPage,
            NoAuthPage,
            routesAccessConditions.filter,
            onboard,
          ),
        },
        {
          path: '/filter/engagement',
          Component: withAuth(
            UnifiedFiltersListPage,
            NoAuthPage,
            routesAccessConditions.filter,
            onboard,
          ),
        },
        {
          path: '/categories',
          Component: withAuth(
            CategoriesListPage,
            NoAuthPage,
            routesAccessConditions.categories,
            onboard,
          ),
        },
        {
          path: '/noauth',
          Component: withAuth(NoAuthPage, NoAuthPage, '', onboard),
        },
        {
          path: '/*',
          Component: NoMatchPage,
        },
      ],
    },
  ],

  { basename: `/${sessionId}` },
)

const App = (props) => {
  useSessionCheck('filters_app_redirector.aspx?r=/filters/list')

  return (
    <AppStateProvider sessionId={sessionId}>
      <ErrorBoundary>
        <ApiProvider>
          <AccountsApiProvider>
            <BeAccountsApiProvider>
              <BeFiltersApiProvider>
                <BeRecipientApiProvider>
                  <BeListApiProvider>
                    <BeMessApiProvider>
                      <GeolocationApiProvider>
                        <ConditionEvaluatorProvider>
                          <RouterProvider router={router} />
                        </ConditionEvaluatorProvider>
                      </GeolocationApiProvider>
                    </BeMessApiProvider>
                  </BeListApiProvider>
                </BeRecipientApiProvider>
              </BeFiltersApiProvider>
            </BeAccountsApiProvider>
          </AccountsApiProvider>
        </ApiProvider>
      </ErrorBoundary>
    </AppStateProvider>
  )
}

export default App
